import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface ModalsState {
  isNewVendorOrderModalVisible: boolean
  isNewOrderModalVisible: boolean
  isEditOrderModalVisible: boolean
  isMissingModalForVendorVisible: boolean
  isTermsOfUseModalVisible: boolean
  isShippingWarningModalVisible: boolean
  isDamageDeviceModalForVendorVisible: boolean
  isUndamageDeviceModalForVendorVisible: boolean
  isAddWarehouseModalVisible: boolean
  isTransferDeviceModalVisible: boolean
  isReturnToWarehouseModalVisible: boolean
  isWarrantyModalVisible: boolean
  isDeviceHistoryLogModalVisible: boolean
  isAccountSettingsModalVisible: boolean
  isPerformanceTestConfirmModalVisible: boolean
  isPerformanceTestFailModalVisible: boolean
  isPerformanceTestReportModalVisible: boolean
}

const initialState: ModalsState = {
  isNewVendorOrderModalVisible: false,
  isNewOrderModalVisible: false,
  isEditOrderModalVisible: false,
  isMissingModalForVendorVisible: false,
  isTermsOfUseModalVisible: false,
  isShippingWarningModalVisible: false,
  isDamageDeviceModalForVendorVisible: false,
  isUndamageDeviceModalForVendorVisible: false,
  isAddWarehouseModalVisible: false,
  isTransferDeviceModalVisible: false,
  isReturnToWarehouseModalVisible: false,
  isWarrantyModalVisible: false,
  isDeviceHistoryLogModalVisible: false,
  isAccountSettingsModalVisible: false,
  isPerformanceTestConfirmModalVisible: false,
  isPerformanceTestFailModalVisible: false,
  isPerformanceTestReportModalVisible: false,
}

export const modalsSlise = createSlice({
  name: "modals",
  initialState,
  reducers: {
    showNewOrderModal: (state, action: PayloadAction<boolean>) => {
      state.isNewOrderModalVisible = action.payload
    },
    showEditOrderModal: (state, action: PayloadAction<boolean>) => {
      state.isEditOrderModalVisible = action.payload
    },
    showMissingModalForVendor: (state, action: PayloadAction<boolean>) => {
      state.isMissingModalForVendorVisible = action.payload
    },
    showTermsOfUseModal: (state, action: PayloadAction<boolean>) => {
      state.isTermsOfUseModalVisible = action.payload
    },
    showShippingWarningModal: (state, action: PayloadAction<boolean>) => {
      state.isShippingWarningModalVisible = action.payload
    },
    showDamageDeviceModalForVendor: (state, action: PayloadAction<boolean>) => {
      state.isDamageDeviceModalForVendorVisible = action.payload
    },
    showUndamageDeviceModalForVendor: (state, action: PayloadAction<boolean>) => {
      state.isUndamageDeviceModalForVendorVisible = action.payload
    },
    showAddWarehouseModal: (state, action: PayloadAction<boolean>) => {
      state.isAddWarehouseModalVisible = action.payload
    },
    showTransferDeviceModal: (state, action: PayloadAction<boolean>) => {
      state.isTransferDeviceModalVisible = action.payload
    },
    showReturnToWarehouseModal: (state, action: PayloadAction<boolean>) => {
      state.isReturnToWarehouseModalVisible = action.payload
    },
    showWarrantyModal: (state, action: PayloadAction<boolean>) => {
      state.isWarrantyModalVisible = action.payload
    },
    showDeviceHistoryLogModal: (state, action: PayloadAction<boolean>) => {
      state.isDeviceHistoryLogModalVisible = action.payload
    },
    showAccountSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.isAccountSettingsModalVisible = action.payload
    },
    showPerformanceTestConfirmModal: (state, action: PayloadAction<boolean>) => {
      state.isPerformanceTestConfirmModalVisible = action.payload
    },
    showPerformanceTestFailModal: (state, action: PayloadAction<boolean>) => {
      state.isPerformanceTestFailModalVisible = action.payload
    },
    showPerformanceTestReportModal: (state, action: PayloadAction<boolean>) => {
      state.isPerformanceTestReportModalVisible = action.payload
    },
  },
})

export const {
  showNewOrderModal,
  showEditOrderModal,
  showMissingModalForVendor,
  showTermsOfUseModal,
  showShippingWarningModal,
  showDamageDeviceModalForVendor,
  showUndamageDeviceModalForVendor,
  showAddWarehouseModal,
  showTransferDeviceModal,
  showReturnToWarehouseModal,
  showWarrantyModal,
  showDeviceHistoryLogModal,
  showAccountSettingsModal,
  showPerformanceTestConfirmModal,
  showPerformanceTestFailModal,
  showPerformanceTestReportModal,
} = modalsSlise.actions

export default modalsSlise.reducer
